import { UPDATE_ANCHOR_POINT } from "../../actions";
import ItemTypes from "../../constants/ItemTypes";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_ANCHOR_POINT:
      if (action.payload.itemType === ItemTypes.TEXT) {
        return {
          ...state,
          layer_set: state.layer_set.map((old_layer) => {
            const layer = { ...old_layer };
            if (layer.layer_id === action.payload.layerId) {
              return {
                ...layer,
                text_elements: layer.text_elements.map((textElement) => {
                  if (textElement.id === action.payload.id) {
                    return {
                      ...textElement,
                      anchor_point: action.payload.anchor_point,
                    };
                  } else {
                    return textElement;
                  }
                }),
              };
            } else {
              return layer;
            }
          }),
        };
      } else {
        return {
          ...state,
          layer_set: state.layer_set.map((old_layer) => {
            const layer = { ...old_layer };
            if (layer.layer_id === action.payload.layerId) {
              return {
                ...layer,
                image_elements: layer.image_elements.map((imageElement) => {
                  return {
                    ...imageElement,
                    anchor_point: action.payload.anchor_point,
                  };
                }),
              };
            } else {
              return layer;
            }
          }),
        };
      }

    default:
      return state;
  }
}
